module.exports = __webpack_public_path__ + "9afc92a825ccb146928706ebd9b3a898.jpg";